'use es6';

import { connect } from 'react-redux';
import { getContentsForLessons, getLessonsForTrack, getTimeForTrackInSeconds } from '../../selectors/trackSelectors';
import TrackIntroductionInformation from '../../components/TrackPage/TrackIntroductionInformation';
function makeMapStateToProps() {
  return (state, ownProps) => {
    const ownPropsWithFakeRouting = {
      trackId: ownProps.track.get('id')
    };
    return {
      // we need to match the router params shape here because it's what the selector is expecting
      trackVideoDurationInSeconds: getTimeForTrackInSeconds(state, ownPropsWithFakeRouting),
      trackLessons: getLessonsForTrack(state, ownPropsWithFakeRouting),
      trackContent: getContentsForLessons(state, ownPropsWithFakeRouting)
    };
  };
}
export default connect(makeMapStateToProps)(TrackIntroductionInformation);